import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { FaPlus, FaFile, FaBookmark, FaTimes, FaCheck } from 'react-icons/fa';
import { Button as ButtonPrime } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import Grid from '@material-ui/core/Grid';
import { Dialog as DialogPrime } from 'primereact/dialog';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import TextField from '@material-ui/core/TextField';
import { InputText } from 'primereact/inputtext';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Tooltip } from '@material-ui/core';
import { Toast } from 'primereact/toast';
import Anotacao from './AnotacaoDemanda';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';
import 'assets/css/documentos.css';
import 'assets/css/geral.css';
import 'assets/css/meus-pedidos.css';
import { getConfiguracoes, iniciaPilhaPendencias } from '../WizardDemanda/ValidacaoWizard';
import {
  iniciaPilhaPendencias as iniciaPilhaPendenciasPedido,
  getConfiguracoes as getConfiguracoesPedido,
  PendenciasWizard,
  setPendencia,
} from '../Wizard/ValidacaoWizard';
import { tema } from '../../util';
import { dominioDemandaCirurgica } from '../../config/database';

class MinhasDemandas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      MinhasDemandas: [],
      listaProcedimento: [],
      listaEquipe: [],
      procedimentoSelecionado: null,
      equipeSelecionada: null,
      loading: false,
      redireciona: false,
      redirecionaPedido: false,
      selectedDateInclusao: null,
      selectedDateSugerida: null,
      pedidoSelecionado: null,
      profissional: null,
      globalFilter: null,
      abreConfirmacaoCancelacaoPedido: false,
      first: 0,
      abreMensagemErro: false,
      mensagemErro: '',
      abreAnotacoes: false,
      observacoesCancelamento: null,
      abrirDialogConfirmacaoSalaCirurgica: false,
      slacaraterEletivo: null,
    };
  }

  differenceInDaysCustom = (startDate, finalDate) => {
    const timeDiff = Math.abs(finalDate.getTime() - startDate.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  };

  limparLocalStoragePedido = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('profissionalResponsavel');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('email');
    localStorage.removeItem('celular');
    localStorage.removeItem('telefone');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('avaliacaoAnestesica');
    localStorage.removeItem('motivoAvaliacaoAnestesica');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('centroCirurgicoPermitido');
    localStorage.removeItem('caraterAtendimentoPermitido');
    localStorage.removeItem('lateralidadePermitida');
    localStorage.removeItem('cidPrincipalPermitido');
    localStorage.removeItem('cidSecundarioPermitido');
    localStorage.removeItem('tipoAcomodacaoPermitido');
    localStorage.removeItem('motivoAntecipacaoPermitido');
    localStorage.removeItem('tipoAnestesiaPadrao');
    localStorage.removeItem('procedimentoPrincipalPermitido');
    localStorage.removeItem('procedimentoSecundarioPermitido');
    localStorage.removeItem('caixaOPMEPermitida');
    localStorage.removeItem('materialConsumivelPermitido');
    localStorage.removeItem('caixaCirurgicaPermitida');
    localStorage.removeItem('hemocomponentePermitido');
    localStorage.removeItem('equipamentoPermitido');
    localStorage.removeItem('pedidoCirurgiaVemDoModelo');
    localStorage.removeItem('salaCirurgia');
    localStorage.removeItem('demandaId');
    localStorage.removeItem('listaModalidadeAtendimento');
  };

  componentDidMount() {
    const {
      statusInicial,
      caraterUrgencia,
      caraterUrgenciaLegado,
      caraterEletivo,
      caraterEletivoLegado,
      modalidadeAmbulatorial,
      acomodacaoPadrao,
      acomodacaoPadraoNome,
      perspectivaValidacaoDosDiasUteis,
      perspectivaValidacaoDosDiasCorridos,
      perspectivaValidacaoDasHorasUteis,
      perspectivaValidacaoDasHorasCorridas,
    } = JSON.parse(localStorage.getItem('configuracoes'));

    this.setState({
      caraterUrgencia,
      caraterUrgenciaLegado,
      caraterEletivo,
      caraterEletivoLegado,
      modalidadeAmbulatorial,
      acomodacaoPadrao,
      acomodacaoPadraoNome,
      perspectivaValidacaoDosDiasUteis,
      perspectivaValidacaoDosDiasCorridos,
      perspectivaValidacaoDasHorasUteis,
      perspectivaValidacaoDasHorasCorridas,
    });

    this.setState({ loading: true });
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    this.setState({ profissional });

    dominioDemandaCirurgica.get('/api/procedimentoCirurgico').then(response => {
      this.setState({ listaProcedimento: response.data.map(proc => proc.descricao) });
    });

    dominioDemandaCirurgica.get('/api/equipesAtivas').then(response => {
      this.setState({ listaEquipe: response.data.map(equipe => equipe.descricao) });
    });
    dominioDemandaCirurgica.get(`/api/statusPedidoDetail/${statusInicial}`).then(response => {
      this.setState({
        perspectivaValidacaoDosDias: response.data.perspectivaValidacaoDosDias,
        slaCaraterUrgencia: response.data.prazoLimiteSLAUrgencia,
        slacaraterEletivo: response.data.prazoLimiteSLAEletivo,
      });
    });
    this.limparLocalStoragePedido();
    this.listarMinhasDemandas();
  }

  pad = n => {
    return n < 10 ? `0${n}` : n;
  };

  listarMinhasDemandas = () => {
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    dominioDemandaCirurgica.get(`/api/minhasDemandas/${profissional.equipe_id}`).then(
      res => {
        this.setState({
          MinhasDemandas: res.data,
          loading: false,
        });
      },
      () => {
        this.setState({ loading: false });
      }
    );
  };

  async handleNovoPedidoPorDemanda(id) {
    this.limparLocalStorage();
    iniciaPilhaPendenciasPedido();
    getConfiguracoesPedido();

    const dataDemanda = {
      idProfissional: this.state.profissional.profissional_id,
      idDemanda: id,
    };

    let pedidoCirurgia = {};

    const [
      responseCaixasOPME,
      responsecaixasMaterial,
      responseCaixasCirurgicas,
      responseHemoderivados,
      responseEquipamentos,
    ] = await Promise.all([
      dominioDemandaCirurgica.get(`/api/itemCaixaOPMEDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemMaterialConsumivelDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemCaixaCirurgicaDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemHemoderivadosDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemEquipamentoDemanda/${id}`),
    ]);

    dominioDemandaCirurgica
      .post('/api/incluirPedidoCirurgiaPorDemanda', dataDemanda)
      .then(
        response => {
          pedidoCirurgia = response.data;
        },
        err => {
          console.log(`ERRO AO INCLUIR COM DEMANDA: ${err.mensagemErro}`);
        }
      )
      .then(() => {
        const cidsSecundarios = pedidoCirurgia.cidSecundario;
        const procedimentosSecundarios = pedidoCirurgia.procedimentoSecundario;
        const {
          centroCirurgico,
          lateralidade,
          cidPrincipal,
          procedimentoPrincipal,
        } = pedidoCirurgia;
        const caixasOPME = [];
        const materialConsumivel = [];
        const caixasCirurgicas = [];
        const hemoderivados = [];
        const equipamentos = [];

        let lista = [];

        lista = responseCaixasOPME.data;
        lista.forEach(caixa =>
          caixasOPME.push({
            id: caixa.item.id,
            idLegado: caixa.item.idLegado,
            codigo: caixa.item.codigo,
            descricao: caixa.item.descricao,
            tipoItem: caixa.item.tipoItem,
            quantidade: caixa.quantidade,
            itemEventual: caixa.itemEventual,
            justificativaEventual: caixa.justificativaEventual,
          })
        );

        lista = responsecaixasMaterial.data;
        lista.forEach(material =>
          materialConsumivel.push({
            id: material.item.id,
            idLegado: material.item.idLegado,
            codigo: material.item.codigo,
            descricao: material.item.descricao,
            tipoItem: material.item.tipoItem,
            quantidade: material.quantidade,
            itemEventual: material.itemEventual,
            justificativaEventual: material.justificativaEventual,
          })
        );

        lista = responseCaixasCirurgicas.data;
        lista.forEach(caixa =>
          caixasCirurgicas.push({
            id: caixa.item.id,
            idLegado: caixa.item.idLegado,
            codigo: caixa.item.codigo,
            descricao: caixa.item.descricao,
            tipoItem: caixa.item.tipoItem,
            quantidade: caixa.quantidade,
          })
        );

        lista = responseHemoderivados.data;
        lista.forEach(hemoderivado =>
          hemoderivados.push({
            id: hemoderivado.item.id,
            idLegado: hemoderivado.item.idLegado,
            codigo: hemoderivado.item.codigo,
            descricao: hemoderivado.item.descricao,
            tipoItem: hemoderivado.item.tipoItem,
            quantidade: hemoderivado.quantidade,
            unidadeMedida: hemoderivado.unidadeMedida,
          })
        );

        lista = responseEquipamentos.data;
        lista.forEach(equipamento =>
          equipamentos.push({
            id: equipamento.item.id,
            idLegado: equipamento.item.idLegado,
            codigo: equipamento.item.codigo,
            descricao: equipamento.item.descricao,
            tipoItem: equipamento.item.tipoItem,
            quantidade: equipamento.quantidade,
          })
        );

        localStorage.setItem('cidsSecundarios', JSON.stringify(cidsSecundarios));
        localStorage.setItem(
          'procedimentosSecundarios',
          JSON.stringify(
            procedimentosSecundarios.map(item => {
              const { procedimento } = item;
              procedimento.quantidade = item.quantidade;
              return procedimento;
            })
          )
        );
        const cod_leito = pedidoCirurgia.codigoLeitoInternacao;
        pedidoCirurgia.paciente.COD_LEITO = cod_leito;
        localStorage.setItem('pedidoCirurgia', JSON.stringify(pedidoCirurgia));
        localStorage.setItem('centroCirurgico', JSON.stringify(centroCirurgico));
        localStorage.setItem('lateralidade', lateralidade ?? '');
        localStorage.setItem('indicacaoClinica', pedidoCirurgia.indicacaoClinica ?? '');
        if (cidPrincipal) localStorage.setItem('cidPrincipal', JSON.stringify(cidPrincipal));
        else localStorage.setItem('cidPrincipal', null);
        if (procedimentoPrincipal !== null) {
          procedimentoPrincipal.quantidade = pedidoCirurgia.quantidadeProcedimentoPrincipal ?? null;
        }
        localStorage.setItem('procedimentoPrincipal', JSON.stringify(procedimentoPrincipal));
        if (caixasOPME) localStorage.setItem('caixasOPME', JSON.stringify(caixasOPME));
        else localStorage.setItem('caixasOPME', []);
        if (materialConsumivel)
          localStorage.setItem('materiaisConsumiveis', JSON.stringify(materialConsumivel));
        else localStorage.setItem('materiaisConsumiveis', []);
        if (caixasCirurgicas)
          localStorage.setItem('caixasCirurgicas', JSON.stringify(caixasCirurgicas));
        else localStorage.setItem('caixasCirurgicas', []);
        if (hemoderivados) localStorage.setItem('hemoderivados', JSON.stringify(hemoderivados));
        else localStorage.setItem('hemoderivados', []);
        if (equipamentos) localStorage.setItem('equipamentos', JSON.stringify(equipamentos));
        else localStorage.setItem('equipamentos', []);
        localStorage.setItem('email', pedidoCirurgia.paciente.email ?? '');
        localStorage.setItem('telefone', pedidoCirurgia.paciente.telefone ?? null);
        localStorage.setItem('celular', pedidoCirurgia.paciente.celular ?? null);
        if (pedidoCirurgia.duracaoEstimada)
          localStorage.setItem('duracaoEstimada', pedidoCirurgia.duracaoEstimada);
        localStorage.setItem('prioridade', null);
        localStorage.setItem('tipoAcomodacao', null);

        const paciente = {
          SEQ_PACIENTE: pedidoCirurgia.paciente.idLegado,
          NRO_PRONTUARIO: pedidoCirurgia.paciente.NRO_PRONTUARIO,
          NOM_PESSOA: pedidoCirurgia.paciente.NOM_PESSOA,
          DAT_NASCIMENTO: pedidoCirurgia.paciente.DAT_NASCIMENTO,
          COD_SEXO: pedidoCirurgia.paciente.COD_SEXO,
          GMR: pedidoCirurgia.paciente.GMR,
        };

        const internacao = {
          DAT_HORA_INTERNACAO: pedidoCirurgia.internacao.dataInternacao,
          SEQ_INTERNACAO: pedidoCirurgia.internacao.idLegado,
          NRO_INTERNACAO: pedidoCirurgia.internacao.numeroInternacao,
        };

        const atendimento = {
          DAT_HORA_ATENDIMENTO: pedidoCirurgia.atendimento.dataAtendimento,
          NRO_FAA: pedidoCirurgia.atendimento.numeroFAA,
          SEQ_ATENDIMENTO: pedidoCirurgia.atendimento.idLegado,
        };

        localStorage.setItem('paciente', JSON.stringify(paciente));
        localStorage.setItem('atendimento', JSON.stringify(atendimento));
        if (pedidoCirurgia.atendimento) {
          setPendencia(0, PendenciasWizard.atendimentoInternacao, 'pendenciasPaciente');
        }
        if (pedidoCirurgia.dataHoraSugerida) {
          const dataSugerida = pedidoCirurgia.dataHoraSugerida
            ? new Date(pedidoCirurgia.dataHoraSugerida)
            : null;
          const dataAtualOnlyDate = new Date();
          dataAtualOnlyDate.setHours(0);
          dataAtualOnlyDate.setMinutes(0);
          const slaCarater = this.state.slacaraterEletivo;
          const diffInDays = this.differenceInDaysCustom(dataSugerida, dataAtualOnlyDate);
          // if (diffInDays <= slaCarater) {
          //   this.showWarn('Data selecionada está dentro do prazo mínimo do SLA.', 'warn');
          //   document.getElementById('dataSugerida').value = '';
          //   return;
          // }
          const localDateTime = `${dataSugerida.getFullYear()}-${this.pad(
            dataSugerida.getMonth() + 1
          )}-${this.pad(dataSugerida.getDate())}T${this.pad(dataSugerida.getHours())}:${this.pad(
            dataSugerida.getMinutes()
          )}`;
          localStorage.setItem('dataSugerida', localDateTime);
        } else localStorage.setItem('dataSugerida', pedidoCirurgia.dataHoraSugerida);
        localStorage.setItem('internacao', JSON.stringify(internacao));
        localStorage.setItem('dataInternacao', internacao.DAT_HORA_INTERNACAO);
        localStorage.setItem(
          'dataInternacao',
          JSON.stringify(pedidoCirurgia.internacao.DAT_HORA_INTERNACAO)
        );
        localStorage.setItem(
          'profissionalResponsavel',
          JSON.stringify(pedidoCirurgia.profissionalResponsavel)
        );
        localStorage.setItem('convenio', JSON.stringify(pedidoCirurgia.atendimento.convenioFull));
        localStorage.setItem('peso', pedidoCirurgia.atendimento.peso ?? null);
        localStorage.setItem('demandaId', id);
        this.setState({ redirecionaPedido: true });
      });
  }

  handleRelatorioDemanda = id => {
    dominioDemandaCirurgica().then(promise => {
      window.open(`${promise.config.baseURL}/resumoDemanda/${id}`);
    });
  };

  handleAbreAnotacoes = id => {
    this.setState({
      pedidoSelecionado: id,
      abreAnotacoes: true,
    });
  };

  codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Código</span>
        <span>{rowData.codigo}</span>
      </>
    );
  };

  pacienteBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Paciente</span>
        <div>
          {rowData.GMR === 'True' && <small className="sinalizacao-gmr">GMR</small>}
          {rowData.eOncologica === '1' && <small className="sinalizacao-oncologica">ONCO</small>}
        </div>
        <span>{rowData.paciente}</span>
      </>
    );
  };

  equipeBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Equipe Requisitante</span>
        <span>{rowData.equipeRequisitante}</span>
      </>
    );
  };

  procedimentoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Procedimento</span>
        <span>{rowData.procedimento}</span>
      </>
    );
  };

  statusBodyTemplate = rowData => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <span className="bolinha-status" style={{ backgroundColor: rowData.corStatus }} />
        <span style={{ marginLeft: '20px' }}>{rowData.status}</span>
      </div>
    );
  };

  dataInclusaoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Inclusão</span>
        <span>
          {new Date(rowData.dataInclusao).toLocaleString([], {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      </>
    );
  };

  dataCirurgiaBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Data Sugerida</span>
        <span>
          {rowData.dataHoraSugerida === 'Não informado'
            ? 'Não informado'
            : new Date(rowData.dataHoraSugerida).toLocaleString([], {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
            })}
        </span>
      </>
    );
  };

  acoesBodyTemplate = rowData => {
    return (
      <div>
        <span className="p-column-title">Ações</span>
        <Tooltip title="Transformar">
          <IconButton
            color="inerit"
            style={{ marginRight: '2px', backgroundColor: tema.transformarDemanda, color: 'white' }}
            onClick={() => this.handleNovoPedidoPorDemanda(rowData.id)}
          >
            <FaCheck size={20} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Resumo">
          <IconButton
            color="inherit"
            style={{ marginRight: '2px', backgroundColor: tema.frio, color: 'white' }}
            onClick={() => this.handleRelatorioDemanda(rowData.id)}
          >
            <FaFile size={20} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cancelar">
          <IconButton
            disabled={rowData.status.toUpperCase() === 'CANCELADO'}
            color="inherit"
            style={{
              marginRight: '2px',
              backgroundColor: tema.quente,
              color: 'white',
            }}
            onClick={() =>
              this.setState({
                abreConfirmacaoCancelacaoPedido: true,
                pedidoSelecionado: rowData.id,
              })
            }
          >
            <FaTimes size={20} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Anotações">
          <IconButton
            color="inherit"
            style={{
              marginRight: '2px',
              color: 'white',
              backgroundColor: tema.antartida,
            }}
            onClick={() => this.handleAbreAnotacoes(rowData.id)}
          >
            {rowData.anotacaoPendente === 1 ? (
              <Badge variant="dot" color="error">
                <FaBookmark size={20} />
              </Badge>
            ) : (
              <FaBookmark size={20} />
            )}
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  formatDate = date => {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = `0${month}`;
    }

    if (day < 10) {
      day = `0${day}`;
    }

    return `${date.getFullYear()}-${month}-${day}`;
  };

  filterDate = (value, filter) => {
    if (
      filter === undefined ||
      filter === null ||
      (typeof filter === 'string' && filter.trim() === '')
    ) {
      return true;
    }

    if (value === undefined || value === null) {
      return false;
    }

    return value === this.formatDate(filter);
  };

  procedimentoItemTemplate = option => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  statusItemTemplate = option => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  handleCancelarPedidoCirurgia = id => {
    if (!this.state.observacoesCancelamento) {
      this.showWarn('É necessário informar o motivo de cancelamento!', 'warn');
      return;
    }
    const dadosCancelamento = {
      observacoesCancelamento: this.state.observacoesCancelamento,
      profissional: this.state.profissional.profissional_id,
    };

    dominioDemandaCirurgica.put(`/api/cancelarDemanda/${id}`, dadosCancelamento).then(
      () => {
        this.setState({
          abreConfirmacaoCancelacaoPedido: false,
          observacoesCancelamento: null,
        });
        this.listarMinhasDemandas();
      },
      err => {
        this.showWarn(`${err}`, 'warn');
      }
    );
  };

  limparLocalStorage = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('equipeRequisitante');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('pendenciasPaciente');
    localStorage.removeItem('pendenciasCirurgia');
    localStorage.removeItem('pendenciasSolicitacao');
    localStorage.removeItem('telefone');
    localStorage.removeItem('email');
    localStorage.removeItem('idPedidoCirurgia');
    localStorage.removeItem('celular');
    localStorage.removeItem('pendenciasSolicitacao');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('avaliacaoAnestesica');
    localStorage.removeItem('motivoAvaliacaoAnestesica');
    localStorage.removeItem('internacao');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('centroCirurgicoPermitido');
    localStorage.removeItem('caraterAtendimentoPermitido');
    localStorage.removeItem('lateralidadePermitida');
    localStorage.removeItem('cidPrincipalPermitido');
    localStorage.removeItem('cidSecundarioPermitido');
    localStorage.removeItem('tipoAcomodacaoPermitido');
    localStorage.removeItem('motivoAntecipacaoPermitido');
    localStorage.removeItem('tipoAnestesiaPadrao');
    localStorage.removeItem('procedimentoPrincipalPermitido');
    localStorage.removeItem('procedimentoSecundarioPermitido');
    localStorage.removeItem('caixaOPMEPermitida');
    localStorage.removeItem('materialConsumivelPermitido');
    localStorage.removeItem('caixaCirurgicaPermitida');
    localStorage.removeItem('hemocomponentePermitido');
    localStorage.removeItem('equipamentoPermitido');
    localStorage.removeItem('pedidoCirurgiaVemDoModelo');
    localStorage.removeItem('salaCirurgia');
    localStorage.removeItem('aprovacaoAutomatica');
    localStorage.removeItem('slaModelo');
    localStorage.removeItem('idModeloPedidoCirurgia');
    localStorage.removeItem('principaisSinaisSintomas');
    localStorage.removeItem('principaisResultadosProvasDiagnosticas');
    localStorage.removeItem('recursosNecessariosAtendimentoPaciente');
    localStorage.removeItem('historiaClinica');
    localStorage.removeItem('areaMedica');
    localStorage.removeItem('eOncologica');
  };

  handleValidaInclusao = () => {
    this.setState({ abrirDialogConfirmacaoSalaCirurgica: true });
  };

  handleNovaDemanda = () => {
    this.limparLocalStorage();
    iniciaPilhaPendencias();
    getConfiguracoes();
    this.setState({ abrirDialogConfirmacaoSalaCirurgica: false, redireciona: true });
  };

  renderFooterDisplay = () => {
    return (
      <div>
        <ButtonPrime
          label="Não"
          icon="pi pi-times"
          onClick={() => this.setState({ abreConfirmacaoCancelacaoPedido: false })}
          className="p-button-text"
        />
        <ButtonPrime
          label="Sim"
          icon="pi pi-check"
          onClick={() => this.handleCancelarPedidoCirurgia(this.state.pedidoSelecionado)}
          autoFocus
        />
      </div>
    );
  };

  renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => this.setState({ abreMensagemErro: false })}
          autoFocus
        />
      </div>
    );
  };

  showWarn(msg, severity) {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 3000,
    });
  }

  render() {
    const pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
      dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
      monthNames: [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
      ],
      monthNamesShort: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ],
      today: 'Hoje',
      clear: 'Limpar',
      dateFormat: 'dd/mm/yy',
      weekHeader: 'Sm',
    };

    // const representativeFilter = <MultiSelect value={this.state.selectedRepresentative} options={this.representatives} itemTemplate={this.representativesItemTemplate} onChange={(e) => this.setState({ selectedRepresentative: e.value })} optionLabel="name" optionValue="name" placeholder="All" className="p-column-filter" />;
    const dateInclusaoFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateInclusao}
        onChange={e => {
          this.setState({ selectedDateInclusao: e.value });
          if (e.value === null) {
            this.dt.filter(null, 'dataInclusao', 'notEquals');
            return;
          }
          this.dt.filter(
            new Date(e.value).toISOString().substring(0, 10),
            'dataInclusao',
            'startsWith'
          );
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const renderFooterDisplayConfirmacaoSalaCirurgica = () => {
      return (
        <div>
          <ButtonPrime
            label="LI E CONCORDO"
            icon="pi pi-check"
            onClick={this.handleNovaDemanda}
            autoFocus
          />
        </div>
      );
    };

    const dateCirurgiaFilter = (
      <Calendar
        locale={pt}
        value={this.state.selectedDateSugerida}
        onChange={e => {
          this.setState({ selectedDateSugerida: e.value });
          if (e.value === null) {
            this.dt.filter(null, 'dataInclusao', 'notEquals');
            return;
          }
          this.dt.filter(
            new Date(e.value).toISOString().substring(0, 10),
            'dataCirurgia',
            'startsWith'
          );
        }}
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        placeholder="Data"
        showButtonBar
      />
    );

    const procedimentosFilter = (
      <Autocomplete
        id="filtroProcedimento"
        options={this.state.listaProcedimento}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ procedimentoSelecionado: value });
          this.dt.filter(value, 'procedimento', 'equals');
        }}
        value={this.state.procedimentoSelecionado}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Procedimento" variant="outlined" />}
      />
    );

    const equipeFilter = (
      <Autocomplete
        options={this.state.listaEquipe}
        getOptionLabel={option => `${option}`}
        onChange={(e, value) => {
          this.setState({ equipeSelecionada: value });
          this.dt.filter(value, 'status', 'equals');
        }}
        value={this.state.equipeSelecionada}
        filterSelectedOptions
        renderInput={params => <TextField {...params} label="Equipe" variant="outlined" />}
      />
    );

    if (this.state.redireciona) {
      return <Redirect from="/admin" to="/admin/wizardDemanda" />;
    }

    if (this.state.redirecionaPedido) {
      return <Redirect from="/admin" to="/admin/wizard" />;
    }

    const header = (
      <>
        <div className="table-header campo-filtro">
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              onInput={e => this.setState({ globalFilter: e.target.value })}
              placeholder="Pesquise pela descrição dos campos..."
              style={{ width: '78vw', height: '6vh' }}
            />
          </span>
        </div>
      </>
    );

    return (
      <div id="laranja">
        <DialogPrime
          header="ATENÇÃO!"
          visible={this.state.abrirDialogConfirmacaoSalaCirurgica}
          modal
          style={{ width: '25vw' }}
          footer={renderFooterDisplayConfirmacaoSalaCirurgica()}
          onHide={() => this.setState({ abrirDialogConfirmacaoSalaCirurgica: false })}
        >
          <div style={{ justifyItems: 'center' }}>
            <span
              style={{
                whiteSpace: 'pre-line',
                display: 'table',
                margin: '0 auto',
                textAlign: 'center',
              }}
            >
              Esclarecemos que a inclusão de uma
              <b> demanda </b>
              não
              <br />
              significa o início de um
              <b> pedido de cirurgia. </b>
              <br />
              A inclusão de pedidos deve ser realizada pela tela “Meus pedidos”
              <br />
              ou por meio do botão de ação “Transformar em pedido”,
              <br />
              presente na tela “Minhas Demandas”.
            </span>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Cancelar Demanda"
          visible={this.state.abreConfirmacaoCancelacaoPedido}
          style={{ width: '65vw' }}
          footer={this.renderFooterDisplay()}
          onHide={() => this.setState({ abreConfirmacaoCancelacaoPedido: false })}
        >
          <div>
            <Container className="container-dialog-cancelar-pedido">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    multiline
                    rows={5}
                    rowsMax={15}
                    name="observacoesCancelamento"
                    variant="outlined"
                    fullWidth
                    id="observacoesCancelamento"
                    label="Observações"
                    value={this.state.observacoesCancelamento}
                    onChange={e => this.setState({ observacoesCancelamento: e.target.value })}
                    inputProps={{
                      maxlength: 500,
                    }}
                    InputLabelProps={{ shrink: true }}
                    className="observacoesCancelamento"
                  />
                </Grid>
              </Grid>
            </Container>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Atenção!"
          visible={this.state.abreMensagemErro}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreMensagemErro: false })}
          footer={this.renderFooterDisplayErro()}
        >
          <div>
            <p>{this.state.mensagemErro}</p>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Anotações"
          className="dialog-anotacao"
          id="dialog-anotacao"
          visible={this.state.abreAnotacoes}
          style={{ width: '85vw' }}
          onHide={() => {
            this.setState({ abreAnotacoes: false });
            this.listarMinhasDemandas();
          }}
        >
          <>
            <Anotacao demanda={this.state.pedidoSelecionado} />
          </>
        </DialogPrime>
        <Toast
          ref={el => {
            this.toast = el;
          }}
          position="top-right"
        />
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <br />
            <Card>
              <CardHeader color="rose" id="centroMinhasDemandas" className="card-header">
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <p className="card-title">
                      <strong>Minhas Demandas</strong>
                    </p>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      onClick={this.handleValidaInclusao}
                      style={{
                        float: 'right',
                        backgroundColor: 'white',
                        color: 'rgb(50, 66, 140)',
                      }}
                      className="botao-nova-demanda"
                      startIcon={<FaPlus color="rgb(50, 66, 140)" size={22} />}
                    >
                      Nova
                    </Button>
                  </Grid>
                </Grid>
              </CardHeader>
              <CardBody className="card-body-0-padding">
                <div className="datatable">
                  <div className="card">
                    <DataTable
                      ref={el => (this.dt = el)}
                      value={this.state.MinhasDemandas}
                      paginator
                      header={header}
                      globalFilter={this.state.globalFilter}
                      rows={10}
                      className="p-datatable-prime"
                      emptyMessage="Sem Demandas"
                      loading={this.state.loading}
                      first={this.state.first}
                      onPage={e => {
                        this.setState({ first: e.first });
                        document.location.href = `${document.location.href.replace(
                          '#centroMinhasDemandas',
                          ''
                        )}#centroMinhasDemandas`;
                      }}
                    >
                      <Column
                        field="codigo"
                        header="Nº Demanda"
                        sortable
                        body={this.codigoBodyTemplate}
                        filter
                        filterPlaceholder="Nº demanda"
                        filterMatchMode="contains"
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="paciente"
                        header="Paciente"
                        sortable
                        body={this.pacienteBodyTemplate}
                        filter
                        filterPlaceholder="Nome"
                        filterMatchMode="contains"
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="procedimento"
                        header="Procedimento principal"
                        sortable
                        body={this.procedimentoBodyTemplate}
                        filter
                        filterPlaceholder="Procedimento"
                        filterMatchMode="contains"
                        headerStyle={{ width: '15vw' }}
                      />
                      <Column
                        field="dataInclusao"
                        header="Data inclusão"
                        sortable
                        body={this.dataInclusaoBodyTemplate}
                        filter
                        filterElement={dateInclusaoFilter}
                        filterFunction={() => this.filterDate()}
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="dataHoraSugerida"
                        header="Data Cirurgia"
                        sortable
                        body={this.dataCirurgiaBodyTemplate}
                        filter
                        filterElement={dateCirurgiaFilter}
                        filterFunction={this.filterDate}
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column
                        field="equipeRequisitante"
                        header="Equipe Responsável"
                        sortable
                        body={this.equipeBodyTemplate}
                        filter
                        filterPlaceholder="Equipe Responsável"
                        filterMatchMode="contains"
                        headerStyle={{ width: '10vw' }}
                      />
                      <Column header="Ações" body={this.acoesBodyTemplate} />
                    </DataTable>
                  </div>
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default MinhasDemandas;
